import { Dayjs } from "dayjs";
import { DateRange, isDateRange } from "types/global";
import { normalizeDateRange } from "./dateRange";
import { dateWithoutTime } from "./time";
import { dateToString } from "./timeFormat";

export const dateDiv = "_"

/**
 * Trasforma un DateRange in una stringa adatta all'URL
 */
export function dateRangeToUrl(range: DateRange): string {
	if (!range) return ""
	const start = dateToString(range.start)
	const end = dateToString(range.end)
	const value = (start != end) ? `${start ?? ""}${dateDiv}${end ?? ""}` : start
	return value ?? ""
}

/**
 * Trasforma una stringa URL in un  DateRange
 */
export function urlToDateRange(url: string): DateRange {
	if (!url || url.trim().length == 0) return {}
	let [startStr, endStr] = url.split(dateDiv)
	if ( endStr == undefined ) endStr = startStr
	const start = dateWithoutTime(startStr)
	const end = dateWithoutTime(endStr)
	const value = normalizeDateRange({ start, end }, null, true)
	return value
}



/**
 * trasforma una data in un parametro adatto a essere inserito nell'url
 * */
export function dateToUrl(value: string | Dayjs | number | DateRange): string {
	let valueUrl = null
	if (isDateRange(value)) {
		valueUrl = dateRangeToUrl(value)
	} else {
		valueUrl = dateToString(value)
	}
	return valueUrl
}


